export default {
  allUsers: 'Alle Benutzer',
  zeroUsers: '0 Benutzer sind ausgewählt',
  users: 'Benutzer',
};
